import { OfferWizardShellView } from '@today/ui-domain'
import { useTranslation } from 'react-i18next'
import { RecipientStepContainer } from '@/components/offers/RecipientStepContainer'
import { useCreateOffer } from '@/hooks/offers/useCreateOffer'
import { useCustomerRecipientPreseed } from '@/hooks/offers/useCustomerRecipientPreseed'
import { useOfferWizardDraft } from '@/hooks/offers/useOfferWizardDraft'
import { OFFERS_NAMESPACE } from '@/i18n'
import { OfferWizardStepId, stepIndexOf } from './offer-wizard-steps'

/**
 * `/offers/new` — wizard Step 1 (TO-122) in the shell: pick the recipient, then
 * Next creates the `{ customerId }` draft and opens Step 2 (TO-125 REQ-101). A
 * `?customerId=` deep link (the Customers list's "Start an offer", TO-697) pre-selects
 * that customer as the recipient.
 */
export function OfferNewPage() {
	const { t } = useTranslation(OFFERS_NAMESPACE)
	const draft = useOfferWizardDraft()
	useCustomerRecipientPreseed(draft)
	const { submit, isSubmitting, error } = useCreateOffer()
	const recipient = draft.recipient
	return (
		<OfferWizardShellView
			t={t}
			activeStep={stepIndexOf(OfferWizardStepId.RECIPIENT)}
			error={error}
			onNext={() => (recipient ? submit({ customerId: recipient.id }) : undefined)}
			nextDisabled={!recipient || isSubmitting}
		>
			<RecipientStepContainer recipient={recipient} onRecipientChange={draft.setRecipient} />
		</OfferWizardShellView>
	)
}
